import { Component, OnInit, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { CommonService } from 'src/app/Shared/Common/common.service';
import * as CryptoJS from 'crypto-js';

@Component({
  selector: 'app-referral-modal',
  templateUrl: './referral-modal.component.html',
  styleUrls: ['./referral-modal.component.css']
})
export class ReferralModalComponent implements OnInit {
  isLoader: boolean = false;
  isModalVisible: boolean = false;
  mobileNumber: string;
  otp: string = '';
  otpSent: boolean = false;
  referOTP: number;
  private modalTimeout: any;

  constructor(private loginCommon: CommonService, @Inject(PLATFORM_ID) private platformId: Object) { }

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.checkAndShowModal();
    }
  }

  checkAndShowModal(): void {
    const referralJoined = localStorage.getItem('referralJoined') === 'true';
    const closedDate = (localStorage.getItem('referralClosedDate') || '').trim();
    const today = new Date().toISOString().split('T')[0];

    // Only show if NOT joined AND NOT closed today
    const shouldShow = !referralJoined && closedDate !== today;

    if (shouldShow) {
      // Clear any existing timeout to prevent multiple timers
      if (this.modalTimeout) {
        clearTimeout(this.modalTimeout);
      }

      // Set timeout for 5 minutes (300,000 ms) - this is a browser-only "nag" popup
      // delay. A pending 5-minute setTimeout is a Zone-tracked macrotask, so scheduling
      // it during SSR would make Angular's stability wait (which CommonEngine.render()
      // blocks on) hang for up to 5 minutes on every request.
      this.modalTimeout = setTimeout(() => {
        this.openModal();
      }, 300000); // 5 minutes = 300,000 milliseconds
    }
  }

  openModal(forceOpen: boolean = false): void {
    console.log('openModal called, forceOpen:', forceOpen);

    if (this.isModalVisible) {
      return;
    }

    if (forceOpen) {
      // For button clicks, force open by clearing restrictions
      localStorage.removeItem('referralJoined');
      localStorage.removeItem('referralClosedDate');
      this.isModalVisible = true;
      return;
    }

    // Normal flow with conditions
    const referralJoined = localStorage.getItem('referralJoined') === 'true';
    const closedDate = (localStorage.getItem('referralClosedDate') || '').trim();
    const today = new Date().toISOString().split('T')[0];

    if (referralJoined || closedDate === today) {
      console.log('Conditions prevent modal from showing');
      return;
    }

    this.isModalVisible = true;
  }

  closeModal(event?: Event): void {
    if (event) {
      event.stopPropagation();
    }

    this.isModalVisible = false;

    // Store only the date part
    const today = new Date().toISOString().split('T')[0];
    localStorage.setItem('referralClosedDate', today);

    // Clear the timeout when modal is closed
    if (this.modalTimeout) {
      clearTimeout(this.modalTimeout);
    }
  }

  joinReferral(): void {
    if (this.otp.toString() === this.referOTP.toString()) {
      const referralCode = this.generateReferralCode(this.mobileNumber);
      this.StoreRefereralCode(referralCode);
      setTimeout(() => {
        this.closeModal();
      }, 2000);
    } else {
      console.error('Invalid OTP');
    }
  }

  generateReferralCode(mobileNumber: string): string {
    const hash = CryptoJS.SHA256(mobileNumber);
    const hashedCode = hash.toString(CryptoJS.enc.Hex);
    return hashedCode.substring(0, 8);
  }

  StoreRefereralCode(refCode: string): void {
    try {
      this.isLoader = true;
      this.loginCommon.SaveReferralInfo(this.mobileNumber, refCode).subscribe({
        next: (res: any) => {
          this.shareReferralCode(refCode);
          this.clearFields();
          // Store joined status in localStorage
          localStorage.setItem('referralJoined', 'true');
          this.isLoader = false;
          this.loginCommon.CallToster('S', 'Thank you for joining BuyRentSale referral program. Your referral code is ' + refCode);
        },
        error: (err: any) => {
          this.isLoader = false;
        }
      });
    } catch (error) {
      this.isLoader = false;
      console.error('Error in StoreRefereralCode:', error);
    }
  }


  shareReferralCode(referralCode: string): void {
    const referralURL = `https://buyrentsale.com/w?referralcode=${referralCode}`;

    const shareData = {
      title: 'Refer a Friend - Buy Rent Sale',
      text: `Join BuyRentSale's referral program and use this referral code: ${referralCode} when you Register to earn rewards!`,
      url: referralURL,
    };

    if (navigator.share) {
      navigator.share(shareData)
        .then(() => console.log('Successfully shared'))
        .catch((error) => console.error('Error sharing:', error));
    } else {
      console.log('Web Share API is not supported in this browser.');
    }
  }

  requestOTP(): void {
    this.isLoader = true;
    this.referOTP = Math.floor(100000 + Math.random() * 900000);
    try {
      let msg = '';
      msg = "" + this.referOTP + " is your verification OTP for Buyrentsale.com. Please do not share this code with anyone. \n\nTeam,\nBuyrentsale.com\nMobile: 9618641100\nEmail: support @buyrentsale.com";
      this.loginCommon.postMsgWithUrlToWhatsapp(this.mobileNumber, msg).subscribe(res => {
        this.otpSent = true;
        this.isLoader = false;
      }, err => {
        this.isLoader = false;
        console.error('Error:', err);
      });
    } catch (error) {
      this.isLoader = false;
      console.error('Error:', error);
    }
  }

  clearFields(): void {
    this.mobileNumber = '';
    this.otp = '';
    this.otpSent = false;
  }

  ngOnDestroy(): void {
    // Clean up the timeout when component is destroyed
    if (this.modalTimeout) {
      clearTimeout(this.modalTimeout);
    }
  }
}